/**
 * ProtectedHospitalRoute — Route guard for Hospital Portal
 */
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useHospitalAuth } from '../hooks/useHospitalAuth';
import { portalPath } from '@/shared/app/portalPath';

export default function ProtectedHospitalRoute({ children }: { children: ReactNode }) {
  const { profile, loading, isAuthenticated } = useHospitalAuth();
  const location = useLocation();
  const p = portalPath('hospital');

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />
          <p className="mt-4 text-sm text-muted-foreground">Verifying hospital access...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !profile) {
    return <Navigate to={p('/login')} state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
